import { IonSpinner } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../ui/Modal';

interface PublishedSharePromptModalProps {
  isOpen: boolean;
  onClose: () => void;
  onShare: () => void;
  isPending?: boolean;
}

export const PublishedSharePromptModal: React.FC<PublishedSharePromptModalProps> = ({
  isOpen,
  onClose,
  onShare,
  isPending = false,
}) => {
  const { t } = useTranslation('listing');

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <h3 className="text-lg font-bold mb-4 pr-8">{t('detail.sharePromptTitle')}</h3>

      <p className="text-sm text-muted-foreground mb-6">
        {t('detail.sharePromptBody')}
      </p>

      <div className="flex gap-2">
        <button
          type="button"
          onClick={onClose}
          disabled={isPending}
          className="flex-1 rounded-lg btn-outline border-border py-2.5 text-sm font-semibold text-foreground active:opacity-80 disabled:opacity-50"
        >
          {t('detail.sharePromptDismiss')}
        </button>
        <button
          type="button"
          onClick={onShare}
          disabled={isPending}
          className="flex-1 rounded-lg bg-brand-primary py-2.5 text-sm font-semibold text-white active:opacity-80 disabled:opacity-50 flex items-center justify-center"
        >
          {isPending ? (
            <IonSpinner name="crescent" className="h-4 w-4" />
          ) : (
            t('detail.sharePromptConfirm')
          )}
        </button>
      </div>
    </Modal>
  );
};
